import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import MaskedInput from "react-text-mask";
import TwoFactorModal from "./TwoFactorModal";
import { AuthServiceContext } from "../../services/auth/authService";
import RecaptchaComponent from "../../components/RecaptchaComponent";
import { useUserContext } from "../../context/user_context";
import TermsModal from "../../components/TermsModal";
import { UserService } from "../../services/user/userService";
import { CommonService } from "../../services/common/commonService";

export default function Signup() {
  const { checkPersonalId, checkUsername, sendSms } =
    useContext(AuthServiceContext);
  const { captchaState, setCaptchaState, send } = useUserContext();
  const [open, setOpen] = useState(false);
  const [askSms, setAskSms] = useState(true);
  const [createEventModal, setCreateEventModal] = useState(false);
  const openCreateEventModal = (bool) => {
    setCreateEventModal(bool ?? !createEventModal);
  };
  const openTermsModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    document.body.classList[createEventModal ? "add" : "remove"](
      "overflow-hidden"
    );
  }, [createEventModal]);

  const [selectedOption, setSelectedOption] = useState("1");
  const [errors, setErrors] = useState({});
  const [apiErrors, setApiErrors] = useState({});
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    fullName: "",
    personalId: "",
    email: "",
    mobilePhone: "",
    recaptchaCode: "",
    isCitizen: true,
    userTypeId: 1,
    smsCode: "",
  });

  // useEffect(() => {
  //   SmsSend();
  // }, [captchaState, send]);

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  useEffect(() => {
    if (!captchaState.token) {
      openCreateEventModal(false);
    }
  }, [captchaState]);

  const handleOptionChange = (event) => {
    const value = event.target.value;
    setFormData({ ...formData, userTypeId: value });
    setSelectedOption(value);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "mobilePhone") {
      value = value.replace(/[^0-9]/g, "");
    }
    //console.log([name, value]);
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = async () => {
    let formErrors = {};
    let valid = true;
    //console.log(captchaState.token);
    //return false;

    if (
      !captchaState.token ||
      captchaState.token === "" ||
      captchaState.token === null ||
      captchaState.token === undefined ||
      captchaState.token === "null"
    ) {
      //alert("Recaptcha is required");
      valid = false;
      formErrors.recaptchaCode = "მონიშნეთ reCAPTCHA";
    }

    if (!formData.fullName.trim()) {
      valid = false;
      formErrors.fullName = "სახელი აუცილებელია";
    }

    if (!formData.userName.trim()) {
      valid = false;
      formErrors.username = "მომხმარებლის სახელი აუცილებელია";
    } else if (formData.userName.trim().length > 1) {
      let isUernameValid = await checkUsername(formData.userName);
      if (!isUernameValid) {
        valid = false;
        formErrors.userName = "მომხმარებლის სახელი დაკავებულია";
      }
    }

    if (!formData.personalId.trim()) {
      valid = false;
      formErrors.personalId = "პირადი ნომერი აუცილებელია";
    } else if (formData.personalId.trim().length > 1) {
      let isPersonalValid = await checkPersonalId(formData.personalId);
      if (!isPersonalValid) {
        valid = false;
        formErrors.personalId = "პირადი ნომერი დაკავებულია";
      }
    }

    const phone = formData.mobilePhone.replace(/[^0-9]/g, "");

    if (!phone.trim()) {
      valid = false;
      formErrors.mobilePhone = "ნომერი აუცილებელია";
    } else if (phone.trim().length !== 9) {
      valid = false;
      formErrors.mobilePhone = "არასწორი ნომერი";
    }

    if (formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email.trim())) {
      valid = false;
      formErrors.email = "არასწორი ელ. ფოსტა";
    }

    if (!formData.password.trim()) {
      valid = false;
      formErrors.password = "პაროლი აუცილებელია";
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/.test(
        formData.password.trim()
      )
    ) {
      valid = false;
      formErrors.password =
        "პაროლი უნდა იყოს მინიმ 6 სიმბოლო, უნდა შეიცავდეს მინიმუმ 1 დიდ და 1 პატარა ასოს და 1 ციფრს";
    }

    if (!formData.confirmPassword.trim()) {
      valid = false;
      formErrors.confirmPassword = "პაროლის გამეორება აუცილებელია";
    } else if (formData.password.trim() !== formData.confirmPassword.trim()) {
      valid = false;
      formErrors.confirmPassword = "პაროლები არ ემთხვევა ერთმანეთს";
    }
    //console.log(formErrors, valid);
    setErrors(formErrors);
    return valid;
  };

  const handleModalOpen = () => {
    setOpen(!open);
  };

  const checkUserPersonal = async () => {
    const personalId = formData.personalId;
    if (personalId.trim().length > 1) {
      const isValid = await checkPersonalId(personalId);
      if (!isValid) {
        setErrors({ ...errors, personalId: "დაკავებულია" });
      } else {
        setErrors({ ...errors });
      }
    }
  };

  const checkUserUsername = async () => {
    const username = formData.userName;
    if (username.trim().length > 1) {
      const isValid = await checkUsername(username);
      if (!isValid) {
        setErrors({ ...errors, userName: "დაკავებულია" });
      } else {
        setErrors({ ...errors });
      }
    }
  };

  const SmsSend = async () => {
    if (askSms) {
      const res = await sendSms({
        mobilePhone: formData.mobilePhone,
        recaptchaCode: captchaState.token,
      });
      if (res == null) openCreateEventModal();
      //setFormData({ ...formData, recaptchaCode: captchaState.token });
    } else if (send) {
      //submit form
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //openCreateEventModal();
    var valid = await validateForm();
    //console.log(valid);
    if (valid) {
      // Submit form data
      console.log("Form is valid, submitting data...");
      await SmsSend();

      //console.log("Form is valid, submitting data...");
    } else {
      console.log(errors);
      console.log("Form is invalid, not submitting data...");
    }
  };

  return (
    <>
      <CommonService>
        <UserService>
          {/* <button onClick={openCreateEventModal}>Open Modal</button> */}
          {open && <TermsModal setOpenTermsModal={openTermsModal} />}
          {createEventModal && (
            <TwoFactorModal
              setCreateEventModal={openCreateEventModal}
              formData={formData}
              askSms={true}
              setFormData={setFormData}
              apiErrors={apiErrors}
              setApiErrors={setApiErrors}
              authType="register"
            />
          )}
        </UserService>
      </CommonService>
      <div className="sm:mb-8 mb-6 text-center">
        <div className="sm:text-[32px]/[42px] text-[30px]/[36px] font-medium mb-2">
          რეგისტრაცია
        </div>
        {/* <span className="text-font-color-100 inline-block">
          Free access to our dashboard.
        </span> */}
      </div>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="flex gap-2 mb-5 w-full">
            {[
              { value: "1", label: "ფიზიკური პირი" },
              { value: "2", label: "იურიდიული პირი" },
            ].map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => handleOptionChange({ target: { value: option.value } })}
                className={`flex-1 py-2 px-4 rounded-lg border text-sm font-medium transition-all duration-200 ${selectedOption === option.value
                    ? "bg-primary text-white border-primary"
                    : "bg-card-color text-font-color-100 border-border-color hover:border-primary"
                  }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
        <div className="form-control mb-5">
          <div className="form-control">
            <label htmlFor="fullname" className="form-label">
              {selectedOption === "1"
                ? "სახელი და გვარი"
                : "კომპანიის დასახელება"}
            </label>
            <input
              type="text"
              id="fullname"
              name="fullName"
              required
              placeholder=""
              className="form-input"
              onChange={handleChange}
            />
            {errors.fullName && (
              <div className="text-danger text-[14px]/[20px]">
                {errors.fullName}
              </div>
            )}
          </div>
        </div>
        <div className="form-control mb-5">
          <label htmlFor="username" className="form-label">
            მომხმარებელი
          </label>
          <input
            type="text"
            id="username"
            name="userName"
            required
            placeholder=""
            className="form-input"
            onChange={handleChange}
            onBlur={checkUserUsername}
          />
          {errors.userName && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.userName}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="personalId" className="form-label">
            {selectedOption === "1"
              ? "პირადი ნომერი"
              : "საიდენტიფიკაციო ნომერი"}
          </label>
          <input
            type="text"
            id="personalId"
            name="personalId"
            required
            placeholder="00000000000"
            className="form-input"
            onChange={handleChange}
            onBlur={checkUserPersonal}
          />
          {errors.personalId && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.personalId}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="phone" className="form-label">
            ტელეფონი
          </label>
          <MaskedInput
            mask={[
              "(",
              /[0-9]/,
              /\d/,
              /\d/,
              ")",
              " ",
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
              /\d/,
            ]}
            guide={true}
            id="phone"
            className="form-input"
            required
            type="text"
            placeholder="(555) 555-555"
            name="mobilePhone"
            onChange={handleChange}
            autoComplete="off"
          ></MaskedInput>
          {errors.phone && (
            <div className="text-danger text-[14px]/[20px]">{errors.phone}</div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="email" className="form-label">
            ელ. ფოსტა
          </label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="name@example.com"
            className="form-input"
            onChange={handleChange}
          />
          {errors.email && (
            <div className="text-danger text-[14px]/[20px]">{errors.email}</div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="password" className="form-label">
            პაროლი
          </label>
          <input
            type="password"
            id="password"
            name="password"
            autoComplete="off"
            required
            placeholder="8+ სიმბოლო"
            className="form-input"
            onChange={handleChange}
          />
          {errors.password && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.password}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="confirmPassword" className="form-label">
            გაიმეორეთ პაროლი
          </label>
          <input
            type="password"
            id="confirmPassword"
            required
            autoComplete="off"
            name="confirmPassword"
            placeholder="8+ სიმბოლო"
            className="form-input"
            onChange={handleChange}
          />
          {errors.confirmPassword && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.confirmPassword}
            </div>
          )}
        </div>
        <div className="form-check mb-30">
          <input
            type="checkbox"
            required
            id="forgotPassword"
            className="form-check-input"
          />
          <label className="form-check-label" htmlFor="forgotPassword">
            ვეთანხმები &nbsp;
            <label
              onClick={handleModalOpen}
              style={{ color: "#4C3575", cursor: "pointer" }}
            >
              წესებსა და პირობებს
            </label>
            {/* <Link to="/" className="text-primary">
              
            </Link> */}
          </label>
        </div>
        <div className="">
          {captchaState.ask && (
            <>
              <div
                className="flex mb-20"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div className="auth-err-cont" style={{ marginTop: "10px" }}>
                  <RecaptchaComponent />
                </div>
                {errors.recaptchaCode && (
                  <div className="text-danger text-[14px]/[20px]">
                    {errors.recaptchaCode}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <button
          type={"submit"}
          className="btn btn-secondary large w-full uppercase"
        >
          რეგისტრაცია
        </button>
        <div className="text-center sm:mt-30 mt-6 text-font-color-100">
          {/* <p>Already have an account?</p> */}
          <Link to="/auth-signin" className="text-primary">
            ავტორიზაცია
          </Link>
        </div>
      </form>
    </>
  );
}
